<template>
  <div class="gr-card col-md-3 form-label d-flex p-3">
    <div class="d-flex flex-column align-items-center">
      <p class="card-title mt-3" style="font-weight: 700">
        {{ title }}
      </p>

      <slot> </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { withDefaults, defineProps } from "vue";

type GrCardProps = {
  title: string;
};

withDefaults(defineProps<GrCardProps>(), {
  title: "",
});
</script>

<style lang="scss" scoped>
.gr-card {
  width: calc(25% - 2.25rem);
  cursor: pointer;
  background-color: #f5f2eb;
  flex: 1;
  box-sizing: border-box;
  flex-basis: calc(25% - 2.25rem);
}
.gr-card:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.card-title {
  text-align: left;
  font-size: 16px !important;
  width: 100%;
  font-weight: 700;
  letter-spacing: 0.19px;
  line-height: 24px;
}

@media (max-width: 1250px) {
  .gr-card {
    width: calc(50% - 4.5rem);
    flex-basis: calc(50% - 4.5rem);
  }
}
</style>
